export function isIOS(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined')
    return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export function isStandaloneMode(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined')
    return false;
  // iOS PWA standalone mode
  // @ts-expect-error - window.navigator.standalone is not defined in the browser
  return Boolean(window.navigator.standalone);
}
